// ======================================================================
// File Name       : superuser
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as actionTypes from '../constants/actionTypes/superUser';
import { USER_AUTHORITY_ROLE } from '../constants/AuthorityConstant';
import store from '../store';

const initialState = {
  recordNum: 0,
  superuserList: [],
  enterpriseList: [],
  userSecernId: null,
  superuserInfo: {
    bySecernId: {},
    allSecernIds: [],
  },
  enterpriseInfo: {
    byCd: {},
    allCds: [],
  },
  isChangedPass: false,
  allServiceRelation: {},
  authorityInfo: {
    roleList: [],
    bySecernId: {},
  },
};

export default function superUser(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SUPERUSER_RECEIVE_SEARCH_RESULT: {
      const { superuserList, recordNum } = action;
      const superuserInfo = superuserList.reduce(
        (acc, cur) => {
          acc.bySecernId[cur.superuserSecernId] = cur;
          acc.allSecernIds.push(cur.superuserSecernId);
          return acc;
        },
        {
          bySecernId: {},
          allSecernIds: [],
        },
      );
      return {
        ...state,
        ...{ superuserList },
        ...{ superuserInfo },
        ...{ recordNum },
      };
    }
    case actionTypes.SUPERUSER_RECEIVE_ENRTERPRISES: {
      const { enterpriseList } = action;
      const enterpriseInfo = enterpriseList.reduce(
        (acc, cur) => {
          acc.byCd[cur.enterpriseCd] = cur;
          acc.allCds.push(cur.enterpriseCd);
          return acc;
        },
        {
          byCd: {},
          allCds: [],
        },
      );
      const superuserList = state.superuserList;
      superuserList && superuserList.length > 0 && superuserList.forEach((superuser) => {
        if (enterpriseInfo.byCd[superuser.enterpriseCd]) {
          superuser.enterpriseName = enterpriseInfo.byCd[superuser.enterpriseCd].enterpriseName;
        }
      });
      return {
        ...state,
        ...{ enterpriseList },
        ...{ enterpriseInfo },
        ...{ superuserList },
      };
    }
    case actionTypes.SUPERUSER_EDIT: {
      const { userSecernId } = action;
      return {
        ...state,
        ...{ userSecernId, isChangedPass: true },
      };
    }
    case actionTypes.SUPERUSER_RECEIVE_ALL_SERVICE: {
      const { authed } = store.getState();
      const { authedUser: { loginSuperuserServiceRoleList } } = authed;

      const allServiceRelationNew = {...state.allServiceRelation};
      const { data } = action;
      const { serviceList } = data;
      const serviceCdListSorted = [];
      const allServiceCdRoleList = [];
      if (serviceList) {
        serviceList.reduce((acc, cur) => {
          if (cur && cur.serviceCd) {
            if (!allServiceRelationNew[cur.serviceCd]) {
              acc[cur.serviceCd] = cur;
            }
          }
          serviceCdListSorted.push(cur.serviceCd);
          // Step 10.2.0 START
          if (loginSuperuserServiceRoleList && loginSuperuserServiceRoleList[cur.serviceCd]) {
            allServiceCdRoleList[cur.serviceCd] =
              loginSuperuserServiceRoleList[cur.serviceCd].superuserServiceRoleSecernId;
          }
          // Step 10.2.0 END
          return acc;
        }, allServiceRelationNew);
      }
      return {
        ...state,
        allServiceRelation: allServiceRelationNew,
        serviceCdListSorted,
        allServiceCdRoleList,
      };
    }

    case actionTypes.SUPERUSER_RECEIVE_SETTING_LIST: {
      const { roleList } = action;
      const serviceCdListSorted = [];
      const allServiceCdRoleList = [];
      const allServiceRelationNew = {...state.allServiceRelation};
      const authorityInfo = roleList.reduce(
        (acc, cur) => {
          const { superuserServiceRoleSecernId, serviceCd, serviceName } = cur;
          acc.bySecernId[superuserServiceRoleSecernId] = cur;
          serviceCdListSorted.push(serviceCd);
          allServiceCdRoleList[serviceCd] = superuserServiceRoleSecernId;
          allServiceRelationNew[serviceCd] = {
            serviceCd,
            serviceName,
          };
          return acc;
        },
        { bySecernId: {}, roleList },
      );
      return {
         ...state,
         authorityInfo,
         serviceCdListSorted,
         allServiceRelation: allServiceRelationNew,
         allServiceCdRoleList,
      };
    }

    case actionTypes.SUPERUSER_RESET_INIT_DATA: {
      const { allServiceRelation, superuserInfo, authorityInfo } = initialState;
      return {
        ...state,
        allServiceRelation,
        superuserInfo,
        authorityInfo,
      };
    }

    default:
      return state;
  }
}
